import {
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@material-ui/core";
import Swal from "sweetalert2";
import { ERROR_COLOR, WHITE } from "../../utils/const";
import useCustomState from "../../hooks/State";

const OrderTypeModal = ({ open }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper", //   border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const orderName = useCustomState("");
  const handleClose = () => {
    open.handleChange(false);
  };
  const alarmFunc = () => {
    Swal.fire({
      toast: true,
      title: "دسترسی به این بخش مقدور نیست",
      color: WHITE,
      timer: 4000,
      position: "bottom-start",
      showConfirmButton: false,
      timerProgressBar: true,
      background: ERROR_COLOR,
    });
  };
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open.value}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open.value}>
          <Box sx={style} style={{ borderRadius: "8px" }}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              افزودن دستور{" "}
            </Typography>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ margin: "5px 0" }}
              >
                <TextField
                  aria-readonly={true}
                  value={orderName.value}
                  fullWidth
                  variant="standard"
                  label="نام دستور"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) => orderName.handleChange(e.target.value)}
                  size="small"
                ></TextField>
              </Grid>
            </Grid>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                style={{ marginTop: "48px" }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Button
                  onClick={alarmFunc}
                  style={{ color: "#fff" }}
                  variant="contained"
                  color="primary"
                >
                  افزودن
                </Button>
                <Button
                  onClick={handleClose}
                  style={{
                    color: "#fff",
                    marginRight: "4px",
                    backgroundColor: ERROR_COLOR,
                  }}
                  variant="contained"
                >
                  بستن
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
export default OrderTypeModal;
